export default __webpack_public_path__ + "static/media/corona2.ed849942.png";